import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";
import { useSelector, useDispatch } from "react-redux";
import { AddVideoInfo } from "../../../redux/slices/mainDataSlice";
import { toast } from "react-toastify";

export default function VideoAdd({ setVideoAdd, videoAdd }) {
  const [mainPhoto, setMainPhoto] = useState("");
  const [videoFile, setVideoFile] = useState();
  const [name, setName] = useState("");
  const dispatch = useDispatch();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      setMainPhoto(reader.result);
    };
    setVideoFile(file);
    reader.onerror = (error) => {
      // Handle file reading error
      console.error("File reading error:", error);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const saveNewVideoInfo = () => {
    dispatch(AddVideoInfo({ name, videoFile }));
    setMainPhoto("");
    setName("");
    toast.info("Adding Video...", { autoClose: false });
    setVideoAdd(false);
  };
  return (
    videoAdd && (
      <div className="video-add-action" data-aos="fade-in">
        <div
          className="content-layout"
          onClick={() => setVideoAdd(false)}
        ></div>
        <div className="container ">
          <div className="title">اضافه فيديو جديده</div>
          <label
            htmlFor="add-video"
            className={mainPhoto ? `image` : `image none`}
          >
            {mainPhoto ? (
              // If a video file is selected, display the video
              <video controls>
                <source src={mainPhoto} type="video/mp4" />
                <source src={mainPhoto} type="video/webm" />
                <source src={mainPhoto} type="video/ogg" />
                Your browser does not support the video tag.
              </video>
            ) : (
              // If no video file is selected, display an image thumbnail
              <img src="/images/add.png" alt="Add" />
            )}
          </label>
          <input
            type="file"
            onChange={handleFileChange}
            name=""
            accept="video/*"
            id="add-video"
            style={{ display: "none" }}
          />
          <div className="text">
            <input
              type="text"
              placeholder="Details Of Video"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="add-btn" onClick={() => saveNewVideoInfo()}>
            اضافه
          </div>
        </div>
      </div>
    )
  );
}
